import TaskTypeEnum = Boo.Objects.Enums.TaskTypeEnum;

export const taskTypeActionFeatures = {
  workblockable: [
    TaskTypeEnum.LocalBusinessCitations,
    TaskTypeEnum.OnsiteRecommendationCreateContent,
    TaskTypeEnum.OnsiteRecommendationImplementation,
    TaskTypeEnum.OnsiteBloggingPostContent,
    TaskTypeEnum.OnsiteBloggingSetUpBlog,
    TaskTypeEnum.OnsiteBlogImplementationManual,
    TaskTypeEnum.OnsiteCopyCreateContentStandard,
    TaskTypeEnum.OnsiteCopyPublishCopy,
    TaskTypeEnum.GoogleSearchConsoleCreationAndInstallation,
    TaskTypeEnum.DomainTransfer,
    TaskTypeEnum.SiteSpeedOptimization,
    TaskTypeEnum.RobotsTxtFileCreationAndImplementation,
    TaskTypeEnum.XMLSitemapCreationAndImplementation,
    TaskTypeEnum.GoogleAnalyticsCreationAndImplementation,
    TaskTypeEnum.SchemaTagImplementation,
    TaskTypeEnum.ThreeHundredOneRedirectMappingAndImplementation,
    TaskTypeEnum.CanonicalDomainImplementation,
    TaskTypeEnum.CanonicalTagImplementation,
    TaskTypeEnum.GoogleMapsIntegration,
    TaskTypeEnum.OnsiteBrokenLinkRepair,
    TaskTypeEnum.ClickTrackingImplementation,
    TaskTypeEnum.CompetitiveAudit,
    TaskTypeEnum.WebPageCreation,
    TaskTypeEnum.WebPageDeletion,
    TaskTypeEnum.MenuEdits,
    TaskTypeEnum.InsertNofollowTagsIntoOnsiteLinks,
    TaskTypeEnum.LoginCredentialTesting,
    TaskTypeEnum.OnsiteCopyImplementationManual,
    TaskTypeEnum.OnsiteRecommendationImplementationManual,
    TaskTypeEnum.MinorEdits,
    TaskTypeEnum.VideoImageImplementation,
    TaskTypeEnum.OnsiteBlogInstallationStandardCMS,
    TaskTypeEnum.BlogMatching,
    TaskTypeEnum.PremiumPreliminaryAudit,
    TaskTypeEnum.PremiumMonthlyCampaignUpdate,
    TaskTypeEnum.PreliminaryAudit,
    TaskTypeEnum.MonthlyCampaignUpdate,
    TaskTypeEnum.RemoveExcessH1Tags,
    TaskTypeEnum.RobotsTxtCreation,
    TaskTypeEnum.SitemapXmlCreation,
    TaskTypeEnum.PreAudit,
    TaskTypeEnum.KeywordResearchBasic,
    TaskTypeEnum.KeywordResearchStandard,
    TaskTypeEnum.KeywordResearchPremium,
    TaskTypeEnum.KeywordResearchRedoBasic,
    TaskTypeEnum.KeywordResearchRedoStandard,
    TaskTypeEnum.KeywordResearchRedoPremium,
    TaskTypeEnum.CreateBoostSitesLandingPage,
    TaskTypeEnum.BoostSitesBuild,
    TaskTypeEnum.ProactiveUnderPerformingKeyword,
    TaskTypeEnum.OnsiteBloggingRevisionStandard,
    TaskTypeEnum.OnsiteBloggingRevisionPremium,
    TaskTypeEnum.UrlEditTask,
    TaskTypeEnum.ClassifiedBusinessListings,
    TaskTypeEnum.BusinessProfileValidationAndAugmentation,
    TaskTypeEnum.ResolveBusinessProfileIssues,
    TaskTypeEnum.KeywordResearchStrategyUpdateResearch,
    TaskTypeEnum.KeywordResearchStrategyUpdateRedo,
    TaskTypeEnum.StandaloneBusinessProfileValidationAndAugmentation,
    TaskTypeEnum.GoogleIntegrationSetup,
    TaskTypeEnum.GoogleIntegrationSetupRedo,
    TaskTypeEnum.PageCreationCreateContent,
    TaskTypeEnum.PageCreationRewriteContent,
    TaskTypeEnum.PageCreationImplementContent,
    TaskTypeEnum.PageCreationImplementation,
    TaskTypeEnum.PageOptimizationCreateContent,
    TaskTypeEnum.PageOptimizationRewriteContent,
    TaskTypeEnum.PageOptimizationImplementContent,
    TaskTypeEnum.PageOptimizationImplementation,
    TaskTypeEnum.EntitySchema
  ],

  canNotWorkblockTaskType: [
    TaskTypeEnum.BusinessProfileValidationAndAugmentation,
    TaskTypeEnum.ResolveBusinessProfileIssues
  ],

  rejectable: [
    TaskTypeEnum.OnsiteCopyReviewStandard,
    TaskTypeEnum.OnsiteCopyPreview,
    TaskTypeEnum.OnsiteRecommendationReview,
    TaskTypeEnum.OnsiteBloggingCustomerPreview,
    TaskTypeEnum.OnsiteImplementationReview,
    TaskTypeEnum.OnsiteCopyImplementationReview,
    TaskTypeEnum.OnsiteBloggingImplementationReview,
    TaskTypeEnum.OnsiteRecommendationImplementationReview
  ],

  rejectableWithoutReason: [
    TaskTypeEnum.OnsiteBloggingReviewStandard,
    TaskTypeEnum.OnsiteBloggingReviewPremium,
    TaskTypeEnum.PageCreationReviewContent,
    TaskTypeEnum.PageCreationReviewImplementation,
    TaskTypeEnum.PageOptimizationReviewContent,
    TaskTypeEnum.PageOptimizationReviewImplementation
  ],

  usesRejectionObject: [
    TaskTypeEnum.OnsiteImplementationReview,
    TaskTypeEnum.OnsiteBloggingImplementationReview,
    TaskTypeEnum.OnsiteCopyImplementationReview,
    TaskTypeEnum.OnsiteRecommendationImplementationReview
  ],

  hasTimer: [
    TaskTypeEnum.OnsiteCopyPublishCopy,
    TaskTypeEnum.GoogleSearchConsoleCreationAndInstallation,
    TaskTypeEnum.DomainTransfer,
    TaskTypeEnum.SiteSpeedOptimization,
    TaskTypeEnum.RobotsTxtFileCreationAndImplementation,
    TaskTypeEnum.XMLSitemapCreationAndImplementation,
    TaskTypeEnum.GoogleAnalyticsCreationAndImplementation,
    TaskTypeEnum.SchemaTagImplementation,
    TaskTypeEnum.ThreeHundredOneRedirectMappingAndImplementation,
    TaskTypeEnum.CanonicalDomainImplementation,
    TaskTypeEnum.CanonicalTagImplementation,
    TaskTypeEnum.GoogleMapsIntegration,
    TaskTypeEnum.OnsiteBrokenLinkRepair,
    TaskTypeEnum.ClickTrackingImplementation,
    TaskTypeEnum.WebPageCreation,
    TaskTypeEnum.WebPageDeletion,
    TaskTypeEnum.MenuEdits,
    TaskTypeEnum.InsertNofollowTagsIntoOnsiteLinks,
    TaskTypeEnum.LoginCredentialTesting,
    TaskTypeEnum.OnsiteCopyImplementationManual,
    TaskTypeEnum.OnsiteRecommendationImplementationManual,
    TaskTypeEnum.MinorEdits,
    TaskTypeEnum.VideoImageImplementation,
    TaskTypeEnum.OnsiteBlogInstallationStandardCMS,
    TaskTypeEnum.BlogMatching,
    TaskTypeEnum.RemoveExcessH1Tags,
    TaskTypeEnum.RobotsTxtCreation,
    TaskTypeEnum.SitemapXmlCreation,
    TaskTypeEnum.PreAudit,
    TaskTypeEnum.KeywordResearchBasic,
    TaskTypeEnum.KeywordResearchPremium,
    TaskTypeEnum.KeywordResearchStandard,
    TaskTypeEnum.KeywordResearchRedoBasic,
    TaskTypeEnum.KeywordResearchRedoPremium,
    TaskTypeEnum.KeywordResearchRedoStandard,
    TaskTypeEnum.KeywordResearchStrategyUpdateResearch,
    TaskTypeEnum.KeywordResearchStrategyUpdateRedo,
    TaskTypeEnum.ProactiveUnderPerformingKeyword,
    TaskTypeEnum.PageCreationImplementation,
    TaskTypeEnum.PageOptimizationImplementation
  ],

  canNotUnlockAndUnassign: [
    TaskTypeEnum.OnsiteBloggingPostContent,
    TaskTypeEnum.OnsiteCopyPreview,
    TaskTypeEnum.OnsiteCopyPublishCopy,
    TaskTypeEnum.LinkAudit,
    TaskTypeEnum.AdvancedAudit,
    TaskTypeEnum.LinkDetoxAudit,
    TaskTypeEnum.ContentAudit,
    TaskTypeEnum.BasicLinkRemoval,
    TaskTypeEnum.StandardLinkRemoval,
    TaskTypeEnum.PremiumLinkRemoval,
    TaskTypeEnum.GooglePlacesOptimization,
    TaskTypeEnum.ExhaustiveAudit,
    TaskTypeEnum.PremiumRoadMapCreation,
    TaskTypeEnum.DuplicateCopyFixImplementation,
    TaskTypeEnum.PremiumSEOAudit,
    TaskTypeEnum.PageCreationPreviewContent,
    TaskTypeEnum.PageCreationImplementContent,
    TaskTypeEnum.PageOptimizationPreviewContent,
    TaskTypeEnum.PageOptimizationImplementContent
  ],

  showCustomerCountry: [
    TaskTypeEnum.LocalBusinessCitations,
    TaskTypeEnum.OnsiteRecommendationCreateContent,
    TaskTypeEnum.OnsiteRecommendationReview,
    TaskTypeEnum.ProactiveUnderPerformingKeyword,
    TaskTypeEnum.EntitySchema
  ],

  showCustomerName: [
    TaskTypeEnum.ProactiveUnderPerformingKeyword,
    TaskTypeEnum.BusinessProfileValidationAndAugmentation,
    TaskTypeEnum.StandaloneBusinessProfileValidationAndAugmentation,
    TaskTypeEnum.EntitySchema
  ],

  showPartnerName: [
    TaskTypeEnum.PremiumMonthlyCampaignUpdate
  ],

  deletable: [
    TaskTypeEnum.BusinessDirectories,
    TaskTypeEnum.WebsiteBookmarking,
    TaskTypeEnum.LocalBusinessCitations,
    TaskTypeEnum.ClassifiedBusinessListings
  ],
  rejectUsingDelete: [
  ]
}
